import { TranscriptSegment } from '../../../store/transcriptSlice';

export interface TranscriptLine {
  key: string;
  text: string;
  live: boolean; // true = the in-progress partial; false = a confirmed segment
}

/**
 * Derives the rolling transcript lines: confirmed segments (oldest → newest) plus any
 * in-progress partial as the final live line, capped to the most recent `maxLines`.
 */
export const toRollingLines = (
  segments: TranscriptSegment[],
  currentPartialText: string,
  maxLines: number,
): TranscriptLine[] => {
  const lines: TranscriptLine[] = segments
    .filter(s => !s.isPartial)
    .map((seg, idx) => ({ key: seg.segmentId || seg.id || `seg-${idx}`, text: seg.text, live: false }));
  if (currentPartialText) {
    lines.push({ key: 'partial', text: currentPartialText, live: true });
  }
  return lines.slice(-maxLines);
};
